import { getSelectionAreaRgb } from "../getSelectionAreaRgb";
import { MIN_POLYGON_POINTS } from "../../polygonPointMutators";
import type { BuildAppliedAreasOverlay } from "./types";

// Only the areas that shaped this view's counts are drawn on the export.
export const buildAppliedAreasOverlay: BuildAppliedAreasOverlay = ({
  selectionAreas,
  isCablesView,
}) => {
  const appliedAreas = selectionAreas.filter(
    (area) =>
      (isCablesView ? area.appliesToRoutes : area.appliesToElements) &&
      area.points.length >= MIN_POLYGON_POINTS,
  );
  if (appliedAreas.length === 0) return null;
  return {
    polygons: appliedAreas.map((area) => ({
      id: String(area.id),
      points: area.points,
      rgb: getSelectionAreaRgb({ mode: area.mode }),
      isSelected: false,
      isDraft: false,
    })),
    hoverPosition: null,
    isDrawing: false,
    isInteractive: false,
    isEditable: false,
    selectedPointId: null,
  };
};
